<template>
  <div class="container p-2">
    <h2 class="text-center mb-5 mt-5">Créditos</h2>

    <vs-row>
      <vs-col
        class="mb-5"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <vs-button @click="verificarCreditos">Verificar Créditos</vs-button>
      </vs-col>
    </vs-row>

    <div class="vx-row">
      <div class="vx-col lg:w-1/2 w-full">
        <div v-html="placaDetalhes"></div>
      </div>
    </div>
  </div>
</template>

<script>
const THREE_MINUTES = 180000;
export default {
  data() {
    return {
      placaDetalhes: null,
    };
  },
  mounted() {
    this.verificarCreditos();
    this.timeToRefresh();
  },
  methods: {
    async verificarCreditos() {
      try {
        const response = await fetch(
          'https://placas.fipeapi.com.br/detalhes?key=a377c482786d21c7f3ede60439116b23',
        );
        const text = await response.text();
        this.placaDetalhes = text;
      } catch (error) {
        console.error('Erro ao buscar detalhes da placa:', error);
      }
    },
    timeToRefresh() {
      setInterval(async () => {
        await this.verificarCreditos();
      }, THREE_MINUTES);
    },
  },
};
</script>

<style scoped>
span {
  display: block;
  margin-bottom: 4px;
}

span.h5 {
  color: #00bfed;
}
</style>
